import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';

import ComplementoOperacionesconderivadosRules from '../../support/rules/complementos/ComplementoOperacionesconderivadosRules';

const rules = ComplementoOperacionesconderivadosRules;

const ComplementoOperacionesconderivados = (props) => {
  const [data, setData] = useState({});
  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
    };

    setData(newData);
  };

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => validate(data), [data]);

  const handleOnAddComplemento = () => {
    const Operacionesconderivados = {
      Version: '1.0',
      MontGanAcum: data.MontGanAcum,
      MontPerdDed: data.MontPerdDed,
    };

    props.onComplementoAdd({ Operacionesconderivados });

    clear();
  };

  const clear = () => {
    setData({});
  };

  const handleOutForm = () => {
    props.onCancel();
  };

  return (
    <>
      <h5 className="text-right">Operaciones con Derivados</h5>

      <Form autoComplete="off">
        <Row>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Monto ganancia acumulable"
              name="MontGanAcum"
              placeholder=""
              help=""
              rules={rules.MontGanAcum}
              value={data.MontGanAcum}
              onChange={handleOnChange}
            />
          </Col>
          <Col sm md={4}>
            <FormControl
              type="number"
              label="Monto pérdida deducible"
              name="MontPerdDed"
              placeholder=""
              help=""
              rules={rules.MontPerdDed}
              value={data.MontPerdDed}
              onChange={handleOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              variant="secondary"
              className="mr-2"
              onClick={handleOutForm}
            >
              Cancelar
            </Button>

            <Button
              variant="primary"
              disabled={!isValid}
              onClick={handleOnAddComplemento}
            >
              Agregar complemento
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ComplementoOperacionesconderivados;
